const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Modal = require("./Modal");
const ModalClose = require("./ModalClose");
const WonkyButton = require("./WonkyButton");
const Checkbox = require("./Checkbox");
const CopyTable = require("../util/CopyTable");
const AssetsUtil = require("../util/AssetsUtil");
const Sounds = require("../util/Sounds");
const WebAnimations = require("../util/WebAnimations");
const withAnimateRef = require("../hoc/withAnimateRef");
const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");

const styles = require("./styles/BugReportModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withAnimateRef(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "BugReportModalView",

		propTypes: {
			step: PT.oneOf(["buttonBody", "inputBody", "message"]),
			messageType: PT.string,
			options: PT.arrayOf(PT.string),
			onClose: PT.func,
			buttons: PT.arrayOf(PT.object),

			// Injected by HOCs
			animateRef: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				option: "",
				error: "",
			};
		},

		makeOptionsBody: function() {
			const setOption = option => this.setState({option});
			const bodyButtons = this.props.options.map((bb, i) => {
				const isSelected = this.state.option === bb;
				const optionClass = isSelected ? styles.selected : styles.option;
				return (
					<div key={"option" + i} className={optionClass}>
						<Checkbox
							className={styles.checkOuter}
							isSelected={isSelected}
							text={bb}
							onClick={() => {
								setOption(bb);
								Sounds.playSound("thud");
							}}
							checkColor="red"
							styleType="trainer"
						/>
					</div>
				);
			});
			return (
				<div className={styles.student}>
					<div className={styles.options}>{bodyButtons}</div>
				</div>
			);
		},

		makeInputBody: function() {
			const descInputStyle = {};
			let errorEl;
			if (this.state.error) {
				errorEl = <div className={styles.error}>{this.state.error}</div>;
			}
			return (
				<div className={styles.inputOuter}>
					<div className={styles.inputWrap}>
						<textarea
							type="text"
							maxLength="2000"
							className={styles.details}
							ref={ref => (this.inputDesc = ref)}
							style={descInputStyle}
							tabIndex={2}
						/>
					</div>
					{errorEl}
				</div>
			);
		},

		makeSubmittedBody: function() {
			return (
				<div className={styles.submitted}>
					{CopyTable.forBugReport()[this.props.messageType]}
				</div>
			);
		},

		render: function() {
			this.checkboxes = {};
			const {step, buttons, onClose, animateRef} = this.props;
			const {option} = this.state;

			let modalClassName;
			if (step === "inputBody") {
				modalClassName = styles.large;
			} else if (step === "buttonBody") {
				modalClassName = styles.medium;
			} else {
				modalClassName = styles.small;
			}

			let renderedButtons = null;
			if (buttons) {
				renderedButtons = buttons.map((b, i) => {
					let clickHandler = b.handleClick;
					if (step === "inputBody") {
						clickHandler = () => {
							// Submit buttons normally have no sounds,
							// so we have to add one here.
							if (b.buttonType === "submit") {
								Sounds.playSound("button-click");
							}
							const desc = this.inputDesc.value;
							if (desc.length >= 10) {
								b.handleClick(this.inputDesc.value);
							} else {
								this.setState({
									error: "Description must be more than 10 characters.",
								});
							}
						};
					} else if (step === "buttonBody") {
						if (!option) {
							clickHandler = () => {
								_.each(this.checkboxes, checkbox => {
									animateRef(checkbox, WebAnimations.checkboxGrow, {
										duration: 700,
										iterations: 1,
										fill: "none",
									});
								});
							};
						} else {
							clickHandler = () => b.handleClick(option);
						}
					}
					return (
						<WonkyButton
							className={styles.button}
							key={"button" + i}
							handleClick={clickHandler || onClose}
							buttonType={b.buttonType}
							tabIndex={3}
						/>
					);
				});
			}

			let headerText;
			if (step !== "message") {
				headerText = <div className={styles.header}>{"Report a Bug"}</div>;
			}

			let subtitle;
			let body;
			if (step === "buttonBody") {
				subtitle = <div className={styles.subtitle}>{"What's wrong?"}</div>;
				body = this.makeOptionsBody();
			} else if (step === "inputBody") {
				subtitle = (
					<div className={styles.subtitle}>{"Describe the issue."}</div>
				);
				body = this.makeInputBody();
			} else {
				body = this.makeSubmittedBody();
			}

			const bgEl = (
				<img className={styles.bg} src={AssetsUtil.getModal("bug-report")} />
			);

			return (
				<Portal container={PORTAL_CONTAINERS.BUG_MODAL}>
					<div className={styles.main}>
						<Modal
							onClose={onClose}
							closeOnBackdropClick={true}
							closeOnEsc={true}
							backdropClass={styles.backdrop}
							modalClass={styles.content + " " + modalClassName}
							levelType="aboveAll"
						>
							{bgEl}
							{headerText}
							{subtitle}
							{body}
							<div className={styles.buttons}>{renderedButtons}</div>
							<ModalClose onClick={this.props.onClose} />
						</Modal>
					</div>
				</Portal>
			);
		},
	})
);
